import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ApiServiceService } from 'src/app/api-service.service';
// import { AppUtility } from 'src/app/interceptor/appUtitlity';
import { AppUtility } from 'src/app/interceptor/apputitlity';
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  @ViewChild('calendar') private calendar: any;
  CustBussinessUnitNumberList: any;
  CustBUList: any;

  constructor(private route: Router, public _apiService: ApiServiceService, public _utility: AppUtility) { }
  errorMsg: string = ''
  errorMsgCheck: string = ''
  itemList: any = [];
  supplierList: any = [];
  RFQDetailreportObject: any = {};
  RFQSupplierreportObject: any = {};
  RFQAssessmentReportObject: any = {};
  RFQOrderreportObject: any = {};
  commonListObject: any = {};
  commonDetailObject: any = {};
  commonSupplierObject: any = {};
  commonOrderObject: any = {};
  enableSupplierDropdown: boolean = false;
  rangeDates: Date[];
  customerDate: any
  dateFrom: any;
  dateTo: any;
  customerReport: any = {};
  BussinessUnitNumberList: any;
  BUList: any;
  BuId: number;
  BusinessMasterId: number;
  roleName: any;
  apqpsupplierId: any = '';
  ppapsupplierId: any = '';
  toolloansupplierid: any = '';
  ngOnInit(): void {
    this.RFQDetailreportObject = {
      itemId: ''
    }
    this.RFQSupplierreportObject = {
      itemId: '',
      supplierId: ''
    }
    this.RFQOrderreportObject = {
      itemId: '',
      supplierId: ''
    }
    this.RFQAssessmentReportObject = {
      assessmentStatus: ''
    }
    this.customerReport = {
      buName: '',
      bussinessName: '',
      rangeDates: []
    }

    this.getStatic();
    this.roleName = this._utility.getLocalStorageDetails();
    let roleName = this._utility.getLocalStorageDetails();
    if (roleName.roleName == 'Supplier') {
      this.enableSupplierDropdown = true;
      this.RFQSupplierreportObject.supplierId = roleName.supplierId;
      this.RFQOrderreportObject.supplierId = roleName.supplierId;
    }
    console.log(this.ppapsupplierId, this.apqpsupplierId, this.toolloansupplierid,);

  }

  breadcrumb = [
    {
      title: 'Reports',
      subTitle: 'Dashboard'
    }
  ]


  getFormInput(event: any, name?: any) {
    if (name == 'list') {
      this.commonListObject = event;
    }

    else if (name == 'detail') {
      this.commonDetailObject = event;
    }

    else if (name == 'supplier') {
      this.commonSupplierObject = event;
    }

    else if (name == 'order_list') {
      this.commonOrderObject = event;
    }
  }

  getStatic() {
    this._apiService.dropdowndata('item').then((res: any) => {
      if (res.success == true) {
        this.itemList = res.returnValue;
      }
    });
    this._apiService.dropdowndata('supplier').then((res: any) => {
      if (res.success == true) {
        this.supplierList = res.returnValue;
      }
    });
    this._apiService.dropdowndata('BussinessUnitNumber').then((res: any) => {
      if (res.success == true) {
        this.BussinessUnitNumberList = res.returnValue;
      }
    });
    this._apiService.dropdowndata('BUMaster').then((res: any) => {
      if (res.success == true) {
        this.BUList = res.returnValue;
      }
    });
     this._apiService.dropdowndata('CustomerBussinessUnitNumber').then((res: any) => {
      if (res.success == true) {
        this.CustBussinessUnitNumberList = res.returnValue;
      }
    });
    this._apiService.dropdowndata('CustomerBUMaster').then((res: any) => {
      if (res.success == true) {
        this.CustBUList = res.returnValue;
      }
    });
  }


  getValue(value: any) {
    // this._utility.loader(true);
    if (value == 'list') {
      let object: any = {};
      Object.keys(this.commonListObject).forEach(key => {
        if (key == 'rangeDates' && this.commonListObject[key]?.length > 0) {
          object.fromDate = this._utility.dateTimeChange(this.commonListObject[key][0])
          object.toDate = this._utility.dateTimeChange(this.commonListObject[key][1])
        }
        else if (this.commonListObject[key] != '') {
          object[key] = this.commonListObject[key];
        }
      })

      console.log(object);
      this._apiService.getRFQListReport(object)
        .then((res: any) => {
          if (res?.type != 'application/json') {
            this._utility.downloadFile(res, "rfqList");
            this._utility.loader(false);
            this._apiService.showMessage('download successfully', 'success')
          }

          else {
            this._utility.loader(false);
            this._apiService.showMessage('No data Found', 'error');
          }
        })
    }

    else if (value == 'details') {
      let object: any = {};
      let object1: any = {};
      Object.keys(this.commonDetailObject).forEach(key => {
        if (key == 'rangeDates' && this.commonDetailObject[key]?.length > 0) {
          object.fromDate = this._utility.dateTimeChange(this.commonDetailObject[key][0])
          object.toDate = this._utility.dateTimeChange(this.commonDetailObject[key][1])
        }
        else if (this.commonDetailObject[key] != '') {
          object[key] = this.commonDetailObject[key];
        }
      })

      if (this.RFQDetailreportObject.itemId != '') {
        object1.itemId = this.RFQDetailreportObject.itemId;
      }
      object1 = { ...object1, ...object };
      this._apiService.getRFQDetailReport(object1)
        .then((res: any) => {
          if (res?.type != 'application/json') {
            this._utility.loader(false);
            this._utility.downloadFile(res, "rfqDetail");
            this._apiService.showMessage('download successfully', 'success')
          }
          else {
            this._utility.loader(false);
            this._apiService.showMessage('No data Found', 'error');
          }
        })
    }

    else if (value == 'supplier') {
      let object: any = {};
      let object1: any = {};
      Object.keys(this.commonSupplierObject).forEach(key => {
        if (key == 'rangeDates' && this.commonSupplierObject[key]?.length > 0) {
          object.fromDate = this._utility.dateTimeChange(this.commonSupplierObject[key][0])
          object.toDate = this._utility.dateTimeChange(this.commonSupplierObject[key][1])
        }
        else if (this.commonSupplierObject[key] != '') {
          object[key] = this.commonSupplierObject[key];
        }
      })
      Object.keys(this.RFQSupplierreportObject).forEach(key => {
        if (this.RFQSupplierreportObject[key])
          object1[key] = this.RFQSupplierreportObject[key];
      })
      object1 = { ...object1, ...object };
      this._apiService.getRFQSupplierReport(object1)
        .then((res: any) => {
          if (res?.type != 'application/json') {
            this._utility.downloadFile(res, "rfqSupplier");
            this._utility.loader(false);
            this._apiService.showMessage('download successfully', 'success')
          }
          else {
            this._utility.loader(false);
            this._apiService.showMessage('No data Found', 'error');
          }
        })
    }

    else if (value == 'order_list') {
      let object: any = {};
      let object1: any = {};
      Object.keys(this.commonOrderObject).forEach(key => {
        if (key == 'rangeDates' && this.commonOrderObject[key]?.length > 0) {
          object.fromDate = this._utility.dateTimeChange(this.commonOrderObject[key][0])
          object.toDate = this._utility.dateTimeChange(this.commonOrderObject[key][1])
        }
        else if (this.commonOrderObject[key] != '') {
          object[key] = this.commonOrderObject[key];
        }
      })
      Object.keys(this.RFQOrderreportObject).forEach(key => {
        if (this.RFQOrderreportObject[key])
          object1[key] = this.RFQOrderreportObject[key];
      })
      object1 = { ...object1, ...object };
      this._apiService.getRFQOrderReport(object1)
        .then((res: any) => {
          if (res?.type != 'application/json') {
            this._utility.downloadFile(res, "rfqOrderDetails");
            this._utility.loader(false);
            this._apiService.showMessage('download successfully', 'success')
          }
          else {
            this._utility.loader(false);
            this._apiService.showMessage('No data Found', 'error');
          }
        })
    }

    else if (value == 'supplier_list') {
      console.log(this.RFQSupplierreportObject);
      let object = {
        supplierId: this.RFQSupplierreportObject.supplierId
      }
      this._apiService.getSupplierReport(object)
        .then((res: any) => {
          if (res?.type != 'application/json') {
            this._utility.downloadFile(res, "SupplierList");
            this._utility.loader(false);
            this._apiService.showMessage('download successfully', 'success')
          }
          else {
            this._utility.loader(false);
            this._apiService.showMessage('No data Found', 'error');
          }
        })
    }

    else if (value == 'assessment_report') {

      let object = {
        assessmentStatus: this.RFQAssessmentReportObject.assessmentStatus
      }
      this._apiService.getAssessmentList(object)
        .then((res: any) => {
          console.log(res);
          if (res?.type != 'application/json') {
            this._utility.downloadFile(res, "assessmentReport");
            this._utility.loader(false);
            this._apiService.showMessage('download successfully', 'success')
          }

          else {
            this._utility.loader(false);
            this._apiService.showMessage('No data Found', 'error');
          }
        })
    }
    else if (value == 'customer') {
      debugger
      // let object = {
      //   dateRange : this.customerReport.rangeDates,
      //   buMaster : this.customerReport.buName,
      //   bussinessMaster : this.customerReport.bussinessMaster
      // }
      let object = {
        FromDate: this.dateFrom ? this.dateFrom : '',
        ToDate: this.dateTo ? this.dateTo : '',
        BuId: this.BuId ? this.BuId : '',
        BusinessMasterId: this.BusinessMasterId ? this.BusinessMasterId : ''
      };

      // this.customerDate = this.rangeDates
      // let formData = new FormData 
      // formData.append('dateRange',this.customerReport.rangeDates);
      // formData.append('buMaster',this.customerReport.buName);
      // formData.append('bussinessMaster',this.customerReport.bussinessName)

      this._apiService.getCustomerList(object)
        .then((res: any) => {
          console.log(res);
          debugger
          if (res?.type != 'application/json') {
            this._utility.downloadFile(res, "customerReport");
            this._utility.loader(false);
            this._apiService.showMessage('download successfully', 'success')
          }

          else {
            this._utility.loader(false);
            this._apiService.showMessage('No data Found', 'error');
          }
        })
    }
    else if (value == 'apqp') {


      this._apiService.getApqpexcel(this.apqpsupplierId)
        .then((res: any) => {
          console.log(res);
          if (res?.type != 'application/json') {
            this._utility.loader(true);
            this._utility.downloadFile(res, "APQPReport");
            this._utility.loader(false);
            this._apiService.showMessage('Download successfully', 'success');
          } else {
            this._utility.loader(false);
            this._apiService.showMessage('No data found', 'error');
          }
        });
    }
    else if (value == 'ppap') {

      this._apiService.getppapexcel(this.ppapsupplierId)
        .then((res: any) => {
          console.log(res);
          if (res?.type != 'application/json') {
            this._utility.loader(true);
            this._utility.downloadFile(res, "PPAPReport");
            this._utility.loader(false);
            this._apiService.showMessage('Download successfully', 'success');
          } else {
            this._utility.loader(false);
            this._apiService.showMessage('No data found', 'error');
          }
        });
    }
    else if (value == 'tooloandetail') {
      this._utility.loader(true);
      this._apiService.gettoolloanexcel(this.toolloansupplierid)
        .then((res: any) => {
          console.log(res);
          this._utility.loader(true);
          console.log(res);

          if (res?.type != 'application/json') {
            this._utility.downloadFile(res, "Tool-Loan-Report");
            this._utility.loader(false);
            this._apiService.showMessage('Download successfully', 'success');
          } else {
            this._utility.loader(false);
            this._apiService.showMessage('No data found', 'error');
          }
        });
    }
  }
  selectedDate() {
    this.dateFrom = moment(this.rangeDates[0]).format('YYYY-MM-DD');
    this.dateTo = moment(this.rangeDates[1]).format('YYYY-MM-DD');
    console.log(this.dateTo, this.dateFrom, this.rangeDates);
    if (this.dateTo != "Invalid date") {
      this.calendar.overlayVisible = false;
      // this.customerReport["rangeDates"] = this.rangeDates;
      this.customerReport.rangeDates = this.rangeDates;
      // this.getFormValue.emit(this.rfqList);       
    }
  }

}
